import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PaymentsPage from "../Pages/PaymentsPage";
import Dashboard from "../Pages/Dashboard";
import Layout from "../Components/Layout/Main";
import FaroRouteTracker from "../observability/FaroRouteTracker";

const AppRoutes = () => {
  return (
    <Router>
        <FaroRouteTracker />
        <Routes >
          <Route path="/" element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/payments" element={<PaymentsPage />} />
          </Route>
        </Routes>
    
    </Router>
  );
};

export default AppRoutes;